import Switches from "./components/Switches";

const Dashboard = () => {
  return (
    <>
      <div>
        <Switches />
      </div>
    </>
  );
};

export default Dashboard;
